import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Link, withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import {Breadcrumb} from 'semantic-ui-react';

import CustomDivider from '../../components/extras/CustomDivider';
import localDB from "../../data/localDB";
import DynamicTable from "../../components/extras/DynamicTable";
import SaleTotal from "../../components/sales/SaleTotal";
import {openModalOtherSales} from "../../actions/ModalOtherSalesActions";
import {dynamicTableAddOrUpdate} from "../../actions/DynamicTableDataAction";
import OtherSaleDialog from "../../components/sale/OtherSaleDialog";

class SalesHistory extends Component {
    constructor() {
        super();
        this.state = {
            table: {
                headers: ['Nº', 'Fecha', 'Sucursal', 'Total', 'Acciones'],
                name: 'Venta',
                title: 'Ventas',
                has_actions: true,
                can_add: true,
                pagination: true,
                navigate: true,
                url: 'sales',
                values: ['id', 'billing_number', 'date', 'branch_office', 'total'],
                child_fields: [{branch_office:'name'}],
                component_fields: [{total:SaleTotal}],
                datetime_fields: ['date'],
                id: 'table_sale_history'
            },
        };
    }

    callbackDynamicTable = (response) => {
        if(response.event === 'navigate'){
            localDB.saveSaleStorage(response.data, 'history');
            this.props.history.push(`/sale/view/${response.data.billing_number}`);
        }
        if(response.event === 'add'){
            this.props.openModalOtherSales({show:true, sale:null});
        }
    };

    componentWillReceiveProps(nextProps){
        if(nextProps.other_sale_select && nextProps.other_sale_select.hasOwnProperty('id')){
            this.props.dynamicTableAddOrUpdate(nextProps.other_sale_select);
        }
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Bisttros - Histórico de Ventas</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/sales'>Finanzas</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Histórico de Ventas</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                <OtherSaleDialog location='sales'/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        other_sale_select: state.get('other_sale_select'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openModalOtherSales(modal){
            dispatch(openModalOtherSales(modal))
        },
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(SalesHistory));


// WEBPACK FOOTER //
// ./src/containers/sales/SalesHistory.js